export const range = length => Array.from({ length }, (_, i) => i + 1)
